import State from 'store/State';
import { selectWidgetInstancesState } from 'widgets/store/selectors';
import { WidgetType } from 'widgets/WidgetType';

export const selectEstimatedTradeCostWidgetsState = (state: State) =>
    selectWidgetInstancesState(state)[WidgetType.EST_TRADE_COST_WIDGET];

export const selectEstimatedTradeCostWidgetState = (
    state: State,
    widgetKey: string
) => selectEstimatedTradeCostWidgetsState(state)[widgetKey];
